import { AuditAreaCell, AuditTypeCell, AuditValueCell, EditActionCell } from '@med-fe/ui';
import { Button } from 'antd';

export const import_columns = [
  {
    title: 'File Name',
    dataIndex: 'fileName',
    key: 'actionType',
    sorter: (a: { fileName: string }, b: { fileName: any }) => a.fileName?.localeCompare(b.fileName),
    sortDirections: ['ascend', 'descend'],
    width: 200,
    ellipsis: true,
  },
  {
    title: 'Upload By',
    dataIndex: 'uploadedFileBy',
    key: 'user',
    sorter: (a: { uploadedFileBy: string }, b: { uploadedFileBy: any }) => a.uploadBy?.localeCompare(b.uploadedFileBy),
    sortDirections: ['ascend', 'descend'],
    width: 120,
    ellipsis: true,
  },
  {
    title: 'Upload Date',
    dataIndex: 'uploadedDate',
    key: 'date',
    sorter: (a: { uploadedDate: string }, b: { uploadedDate: any }) => a.uploadedDate?.localeCompare(b.uploadedDate),
    sortDirections: ['ascend', 'descend'],
    width: 110,
    ellipsis: true,
  },
  {
    title: 'Total Rows',
    dataIndex: 'totalRows',
    key: 'totalRows',
    width: 80,
    ellipsis: true,
  },
  {
    title: 'Validate Records',
    dataIndex: 'officeImportId',
    key: 'validate',
    ellipsis: true,
    width: 170,
  },
  {
    title: 'Process Import',
    dataIndex: 'officeImportId',
    key: 'processImport',
    width: 250,
    ellipsis: true,
  },
  {
    title: 'View Snapshot',
    dataIndex: 'officeImportId',
    key: 'snapshot',
    width: 130,
    ellipsis: true,
  },
  {
    title: 'Download File',
    dataIndex: 'officeImportId',
    key: 'download',
    width: 125,
    ellipsis: true,
  },
  {
    title: 'Delete File',
    dataIndex: 'officeImportId',
    key: 'deleteFile',
    width: 100,
    ellipsis: true,
  },
];
